import { TasksGenerator } from 'components/elearning/tasks/tasks-generator';
import { useTopic } from 'hooks/useTopic';
import { Inroduction } from '../hand-hygiene/inroduction';
import { PreparingYourHandsToWork } from '../hand-hygiene/preparing-your-hands-to-work';
import { ProperHandWashing } from '../hand-hygiene/proper-hand-washing';
import { ProperHandDisinfection } from '../hand-hygiene/proper-hand-disinfection';
import { HandHygieneAndMedicalGloves } from '../hand-hygiene/hand-hygiene-and-medical-gloves';
import { FiveMomentsHandHygiene } from '../hand-hygiene/five-moments-hand-hygiene';
import { HandHygieneQuiz } from '../hand-hygiene/quiz';

export const GenericTopicPage = () => {
    const { currentIssue, tasks, correctAnswer, isAnswerChecked } = useTopic();

    const issueComponentMap : Record<number, JSX.Element> = {
        9: <Inroduction />,
        10: <PreparingYourHandsToWork />,
        11: <ProperHandDisinfection />,
        12: <ProperHandWashing />,
        13: <HandHygieneAndMedicalGloves />,
        14: <FiveMomentsHandHygiene />,
        15: <HandHygieneQuiz />
    };
    
    const legacyComponent = currentIssue && currentIssue.id ? issueComponentMap[currentIssue.id] : null;
    
    return (
        <div className="container">
            {legacyComponent ?? (
                <TasksGenerator
                    tasks={tasks}
                    isChecked={isAnswerChecked}
                    correctAnswer={correctAnswer}
                    isQuiz={false}
                />
            )}
        </div>
    );
};